"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoMedia = exports.ImageMedia = void 0;
const zod_1 = require("zod");
exports.ImageMedia = zod_1.z.object({
    image: zod_1.z.string().nullable().optional(), // not really optional,
    cdn01: zod_1.z.string().nullable().optional(), // not really optional,
});
const NewVideoMedia = zod_1.z.object({
    videoSourceType: zod_1.z.string().optional(),
    videoThumbnailUrl: zod_1.z.string().nullable().optional(),
    videoUrl: zod_1.z.string(),
});
const OldVideoMedia = zod_1.z.object({
    video: zod_1.z.string().nullable().optional(), // not really optional
    cdn01: zod_1.z.string().nullable().optional(), // not really optional
    image: zod_1.z.string().nullable().optional(),
    videoSourceType: zod_1.z.string().optional(),
});
exports.VideoMedia = zod_1.z.union([OldVideoMedia, NewVideoMedia]);
